import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { Icon } from '@seeqdev/qomponents';
import { FormulaEditorAsync } from '@/formula/FormulaEditorAsync.molecule';

export interface FormulaItemTableOption {
  key: string;
  display: string;
  formula?: string;
}

export interface FormulaItemTableIF {
  options: FormulaItemTableOption[];
  testId?: string;
  extraClassNames?: string;
}

export const FormulaItemTable: React.FunctionComponent<FormulaItemTableIF> = (props) => {
  const { extraClassNames, options, testId } = props;

  const [expandedKeys, setExpandedKeys] = useState<Set<string>>(new Set());

  const toggleRow = useCallback((option: FormulaItemTableOption) => {
    setExpandedKeys((prev) => {
      const next = new Set(prev);
      if (next.has(option.key)) {
        next.delete(option.key);
      } else {
        next.add(option.key);
      }
      return next;
    });
  }, []);

  return (
    <table
      className={classNames('table table-striped table-condensed mb0', extraClassNames)}
      data-testid={testId}
      tabIndex={0}>
      <tbody>
        {options.map((option) => {
          const isOpen = expandedKeys.has(option.key);
          return (
            <tr key={option.key}>
              <td colSpan={1}>
                <div>
                  <div className="flexColumnContainer flexSpaceBetween">
                    <span className="flexGrowShrink">{option.display}</span>
                    {option.formula && (
                      <Icon
                        icon="fc fc-formula"
                        onClick={() => toggleRow(option)}
                        testId={`${testId}Icon-${option.key}`}
                        extraClassNames="mt3"
                      />
                    )}
                  </div>

                  {isOpen && option.formula && (
                    <div>
                      <FormulaEditorAsync
                        formula={option.formula}
                        readOnly={true}
                        showLineNumbers={false}
                        lineWrapping={true}
                      />
                    </div>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
